import React, { Component } from "react";
import { FoxIcon, OwnIcon } from '@icons/module-icons';
import './index.footer.global.scss'
import { OwnImage } from "@img/module-images";

const FOOTER_BOTTOM_DEF = [
  {
    icon: 'wallet',
    title: 'Most Cheap Price',
    detail: 'We provide a very complete service features at a very cheap price. We dare to compare with the service from other places'
  },
  {
    icon: 'star-full',
    title: 'The Best Results From The Best',
    detail: 'We will give our best results to you, and make your efforts more advanced with the digital world'
  },
  {
    icon: 'terminal',
    title: 'Expert and Professional Team',
    detail: 'Our team consists of professionals who have proven reliable, both in education and experience in solving existing problems.'
  },

  // {
  //   icon: '',
  //   title: '',
  //   detail: ''
  // },
  
]

const defaultProps = {
  bottomMenu: FOOTER_BOTTOM_DEF,
  title: "Why Choose Us"
}
export class FooterGlobal extends Component<any> {
  static defaultProps = defaultProps;
  render(){
    const { props } = this;
    return(
      <footer className="footer-main">
        <div className="onecol onebg-gray-85" id="contact">
          <div className="m1 oneinfo">
            <div className="onetitle onec-blue">Contact</div>
            <div>We allways active on social media, Please dont be hesitate to contact us</div>
          </div>
          <div className=" oneuser onecol onecontainer">			
            <div className="item ml6 oneleft onelinkhover"><a href="http://facebook.com/ridwanfoxdream" target="_blank">
              {/* <div className="icon oneicon one-fp onec-blue rotate"></div> */}
              <FoxIcon icon = {"fp"} className="icon oneicon one-fp onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />
              <div className="text">Facebook</div>
              <div className="text">@Ridwan_foxdream</div></a>
            </div>
            <div className="item ml6 oneleft item onelinkhover"><a href="http://facebook.com/foxdreem.co.id" target="_blank">
              {/* <div className="icon oneicon one-facebook2 onec-blue rotate"></div> */}
              <FoxIcon icon = {"facebook2"} className="icon oneicon one-facebook2 onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />

              <div className="text">Facebook Fans Page</div>
              <div className="text">@foxdreem.co.id</div></a>
            </div>
            <div className="item ml6 oneleft item onelinkhover"><a href="http://telegram.me/@Ridwan_foxdream" target="_blank">
              {/* <div className="icon oneicon one-telegram onec-blue rotate"></div> */}
              <FoxIcon icon = {"telegram"} className="icon oneicon one-telegram onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />

              <div className="text">Telegram</div>
              <div className="text">@@Ridwan_foxdream</div></a>
            </div>
            <div className="item ml6 oneleft item onelinkhover"><a href="http://instagram.com/@Ridwan_foxdream" target="_blank">
              {/* <div className="icon oneicon one-instagram onec-blue rotate"></div> */}
              <FoxIcon icon = {"instagram"} className="icon oneicon one-instagram onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />

              <div className="text">Instagram</div>
              <div className="text">@@Ridwan_foxdream</div></a>
            </div>
            <div className="item ml6 oneleft item onelinkhover"><a href="https://wa.me/+6281228132092" target="_blank">
              {/* <div className="icon oneicon one-whatsapp onec-blue rotate"></div> */}
              <FoxIcon icon = {"whatsapp"} className="icon oneicon one-whatsapp onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />

              <div className="text">WhatsApp / Phone</div>
              <div className="text">+62-8122-8132-092</div></a>
            </div>
            <div className="item ml6 oneleft item onelinkhover"><a href="https://id.linkedin.com/in/ridwanfoxdream" target="_blank">
              {/* <div className="icon oneicon one-linkedin onec-blue rotate"></div> */}
              <FoxIcon icon = {"linkedin"} className="icon oneicon one-linkedin onec-blue rotate" style ={{fontSize: "4em", cursor: "pointer"}} />

              <div className="text">Linkedin</div>
              <div className="text">@Ridwanfoxdream</div></a>
            </div>
          </div>
        </div>
        <div className="onecol onefooter onebg-moredarkungu" id="why-us">
          <div className="onecontainer s1 backimg after" style = {{backgroundImage: `url(${OwnImage.Back})`, margin: 0, paddingBottom: 0, overflow: 'hidden' }}>
            <div className="m1 oneinfo absolute">
              <div className="onetitle onec-blue">{props.title}</div>
              <div>We allways do the best for you</div>
            </div>
            <div className="l1 fexbox">
              { props.bottomMenu?.map?.((item: any, i: any) => (
                <div className="l3 oneleft onec-white absolute" key = {i}>
                  <div className="oneme childflex" style={{padding: '15px'}}>
                    {/* <div className={`oneicon ${item.icon}`} style={{textAlign: 'center', fontSize: '3em' }}></div> */}
                    <FoxIcon icon = {item.icon} className="oneicon one-location" style={{textAlign: 'center', fontSize: '3em', display: "block" }} />
                    <div className="title noborder onec-blue" style={{border: 'none'}}>{item.title}</div>
                    <div style={{color: '#9E9E9EFF'}}>{item.detail}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="l1">
              <div className="m1 oneleft onec-white absolute" style={{padding: '20px'}} >
                {/* <label className="oneicon one-location" style={{padding: '5px', fontSize: '1.3em' }}></label>  */}
                <FoxIcon icon = {"location"} className="oneicon one-location" style={{padding: '5px', fontSize: '1.3em', display: "inline-block" }} />
                <label style={{padding: '5px'}}>Jln. Glagahsari , Gang Flamboyan nomor 368A, Yogyakarta</label>
              </div>
            </div>
          </div>
          <div className="onesign s1 onebg-moredarkungu">
            <div style={{padding: '5px', fontSize: '.8em' }}>Foxdreem beta version 2.0.1</div>
            <div style={{padding: '5px', fontSize: '1.1em', color: '#c5c5c5' }}>
              Copyright &#169; {new Date().getFullYear()} Ridwan Foxdream.
            </div>
          </div>
        </div>
      </footer>
    )
  }
}